import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../utils/TableCustomStyles";
import Select, { createFilter } from "react-select";
import { smallFormSelectCustomStyles } from "../../utils/SelectCustomStyles";
import { importExportTableCustomStyles } from "../../utils/TableCustomStyles";

function VesselServiceMaster() {
  const addform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [portsList, setPortsList] = useState([]);
  const [updatePorts, setUpdatePorts] = useState([]);
  const [portsForUpdate, setPortsForUpdate] = useState([]);
  const [vesselPorts, setVesselPorts] = useState([]);
  const [vesselPortTerminal, setVesselPortTerminal] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];

  const [canvasFullScreen, setCanvasFullScreen] = useState(false);
  const [showNameError, setShowNameError] = useState(false);
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [updateId, setUpdateId] = useState("");

  const [name, setName] = useState("");
  const [status, setStatus] = useState("ACTIVE");

  const [updateName, setUpdateName] = useState("");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [deleteRecordId, setDeleteRecordId] = useState(null);

  const [showServiceDetails, setShowServiceDetails] = useState(true);
  const [showServicePorts, setShowServicePorts] = useState(false);
  const [showServiceFreights, setShowServiceFreights] = useState(false);
  const [showAddVesselPortLoader, setShowAddVesselPortLoader] = useState(false);
  const [showAddNameTooltip, setShowAddNameTooltip] = useState(false);
  const [showUpdateNameTooltip, setShowUpdateNameTooltip] = useState(false);

  const [portsErrorMessage, setPortsErrorMessage] = useState("");

  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const [showPortsTerminalTooltip, setShowPortsTerminalTooltip] =
    useState(false);

  const validateAddForm = () => {
    if (!name.trim()) {
      setShowNameError(true);
      return false;
    }
    return true;
  };

  const validateUpdateForm = () => {
    if (!updateName.trim()) {
      setShowUpdateNameError(true);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (!showUpdateCanvas) {
      setPortsErrorMessage("");
      setShowPortsTerminalTooltip(false);
      setVesselPorts([]);
      setUpdatePorts([]);
      setPortsForUpdate([]);
    }
  }, [showUpdateCanvas]);

  useEffect(() => {
    // Sync vesselPorts with portsForUpdate when ports are removed
    if (portsForUpdate.length === 0) {
      setVesselPorts([]);
    }
  }, [portsForUpdate]);

  // ----  any port with no terminal available ----
  const hasPortWithNoTerminal = vesselPorts.some(
    (port) =>
      vesselPortTerminal.filter((t) => t.port === (port.id || port.value))
        .length === 0,
  );
  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) {
        setLoggedInUser(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getVesselService = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/vesselservice/",
      );
      setTimeout(() => {
        if (response) {
          setData(response.data);
          setDataPending(false);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching vessel service data! Try again.");
    }
  };

  const getPorts = async () => {
    try {
      const ports_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/",
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          const ports_dict = {};
          ports_dict["value"] = response.data[i]?.["id"];
          ports_dict["label"] = response.data[i]?.["name"];
          ports_dict["index"] = response.data[i]?.["index"];
          ports_array.push(ports_dict);
        }
      }
      setPortsList(ports_array);
    } catch (err) {
      toast.error("Error in fetching ports data! Try again.");
    }
  };

  const getTerminals = async () => {
    try {
      const terminals_array = [];
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/terminal/",
      );
      if (response) {
        for (let i = 0; i < response.data.length; i++) {
          const terminals_dict = {};
          terminals_dict["value"] = response.data[i]?.["id"];
          terminals_dict["label"] = response.data[i]?.["name"];
          terminals_dict["port"] = response.data[i]?.["port"];
          terminals_array.push(terminals_dict);
        }
      }
      setVesselPortTerminal(terminals_array);
    } catch (err) {
      toast.error("Error in fetching terminal data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array);
      }
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteModalOpen = (row) => {
    setShowDeleteModal(true);
    setDeleteRecordId(row.id);
  };

  useEffect(() => {
    getVesselService();
    getPorts();
    getTerminals();
    getLoggenInUser();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  const get_user = (userjson) => {
    console.log("userjson----------", userjson)
    if (!userjson == "") {
      const user_data = JSON.parse(userjson);
      return user_data?.name;
    } else {
      return "None";
    }
  };

  const columns = [
    {
      name: "Service Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => get_user(row.created_by),
      sortable: true,
    },
    {
      name: "Created On",
      selector: (row) => row.created_on.slice(0, 10),
      sortable: true,
    },
    {
      name: "Action",
      right: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:vesselservice:update",
          ) ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => {
                resetPortsState();

                setShowUpdateNameError(false);
                setShowUpdateNameTooltip(false);
                setPortsErrorMessage("");
                setShowPortsTerminalTooltip(false);

                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes(
            "master:vesselservice:delete",
          ) ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  // ---- Helper: auto-detect return port (turnaround point) ----
  // Finds the first port in the array whose value appears again later → that's the turnaround
  const detectReturnPortIndex = (ports) => {
    const seenValues = [];
    for (let i = 0; i < ports.length; i++) {
      const portId = ports[i].id || ports[i].value; // ← fix
      if (seenValues.includes(portId)) {
        return i - 1 >= 0 ? i - 1 : 0;
      }
      seenValues.push(portId); // ← fix
    }
    return ports.length - 1;
  };
  // ---- Auto-set return port if none is set ----
  const autoSetReturnPort = async (ports, currentUpdateId) => {
    const hasReturnPort = ports.some((p) => p.return_port === "YES");
    if (!hasReturnPort && ports.length > 0) {
      const returnIndex = detectReturnPortIndex(ports);
      const returnPort = ports[returnIndex];
      if (returnPort) {
        const data = {
          id: currentUpdateId,
          port: returnPort,
          is_return_port: "YES",
          modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
        };
        try {
          const response = await axios.post(
            process.env.REACT_APP_BACKEND_API_URL +
              "/master/vesselservice/setreturnport/",
            data,
            { headers: { "content-type": "application/json" } },
          );
          if (response.status === 200) {
            setVesselPorts(Object.values(response.data?.result?.sequence));
          }
        } catch (err) {
          // silent — not a blocking error
        }
      }
    }
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateStatus(row.status);
    setPortsErrorMessage("");
    setShowPortsTerminalTooltip(false);

    const sequence_ports = row.sequence;
    const orderedOptions = Object.values(sequence_ports).sort(
      (a, b) => a.index - b.index,
    ); // ← sort
    const selectOptions = orderedOptions.map((item) => ({
      value: item.id,
      label: item.name,
      index: item.index,
      unique_id: item.unique_id,
      id: item.id,
      terminal_id: item.terminal_id,
      terminal_name: item.terminal_name,
      return_port: item.return_port,
    }));

    setUpdatePorts(selectOptions);
    setPortsForUpdate(selectOptions);

    const ports = orderedOptions; //  use already-sorted orderedOptions
    setVesselPorts(ports);

    autoSetReturnPort(ports, row.id);
  };

  const addVesselService = async (e) => {
    e.preventDefault();
    if (!validateAddForm()) return;

    if (showAddLoader) return;
    setShowAddLoader(true);

    const data = {
      name: addform.current.name.value,
      status: addform.current.status.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.post(
      process.env.REACT_APP_BACKEND_API_URL + "/master/vesselservice/",
      data,
      { headers: { "content-type": "application/json" } },
    );

    if (response.status === 200) {
      toast.success("Vessel Service Created Successfully");
    }

    setName("");
    setStatus("ACTIVE");
    getVesselService();
    setShowAddCanvas(false);
    setShowAddLoader(false);
  };

  const updateVesselService = async (e) => {
    e.preventDefault();

    if (!validateUpdateForm()) return;

    if (showUpdateLoader) return;
    setShowUpdateLoader(true);
    const id = updateId;

    const data = {
      name: updateName,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL +
        "/master/vesselservice/" +
        id +
        "/",
      data,
      { headers: { "content-type": "application/json" } },
    );

    if (response.status === 200) {
      toast.success("Vessel Service Updated Successfully");
    }

    getVesselService();
    setShowUpdateCanvas(false);
    setShowUpdateLoader(false);
  };

  const deleteVesselService = async (e) => {
    e.preventDefault();
    setShowDeleteLoader(true);
    const id = deleteRecordId;

    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_API_URL +
        "/master/vesselservice/" +
        id +
        "/",
    );

    if (response.status === 200) {
      toast.success("Vessel Service Deleted Successfully");
    }

    getVesselService();
    setShowDeleteLoader(false);
    setShowDeleteModal(false);
  };

  // const selectedServicePortForUpdate = (portdata) => {
  //   const existingValues = portsForUpdate.map(o => o.value);
  //   const newSelections = portdata.filter(o => !existingValues.includes(o.value));
  //   const updated = [...portsForUpdate.filter(o => portdata.find(n => n.value === o.value)), ...newSelections];
  //   setPortsForUpdate(updated);
  //   setUpdatePorts(updated);
  // }

  // const selectedServicePortForUpdate = (selectedOption, actionMeta) => {
  //   if (actionMeta.action === "select-option") {
  //     const newItem = { ...actionMeta.option, id: Date.now() };
  //     setPortsForUpdate((prev) => [...prev, newItem]);
  //     setUpdatePorts((prev) => [...prev, newItem])
  //   } else if (actionMeta.action === "remove-value" || actionMeta.action === "pop-value") {
  //     setPortsForUpdate((prev) => prev.filter((item) => item.id !== actionMeta.removedValue.id));
  //     setUpdatePorts((prev) => prev.filter((item) => item.id !== actionMeta.removedValue.id))
  //   } else if (actionMeta.action === "clear") {
  //     setPortsForUpdate([]);
  //     setUpdatePorts([]);
  //   }
  // };

  const selectedServicePortForUpdate = (selectedOption, actionMeta) => {
    setPortsErrorMessage("");
    setShowPortsTerminalTooltip(false); // clear validation on change
    if (actionMeta.action === "select-option") {
      const newItem = {
        ...actionMeta.option,
        id: actionMeta.option["value"],
        name: actionMeta.option["label"],
        unique_id: Date.now(),
        index: portsForUpdate.length + 1,
      };
      setPortsForUpdate((prev) => [...prev, newItem]);
      setUpdatePorts((prev) => [...prev, newItem]);
    } else if (actionMeta.action === "remove-value" || actionMeta.action === "pop-value") {
      console.log("actionMeta.action", actionMeta.action);
      setPortsForUpdate((prev) => {
        const updatedList = prev.filter(
          (item) => item.unique_id !== actionMeta.removedValue.unique_id,
        );
        return updatedList.map((item, i) => ({ ...item, index: i + 1 }));
      });
      setUpdatePorts((prev) => {
        const updatedList = prev.filter(
          (item) => item.unique_id !== actionMeta.removedValue.unique_id,
        );
        return updatedList.map((item, i) => ({ ...item, index: i + 1 }));
      });
      setVesselPorts((prev) =>
        prev
          .filter((p) => p.unique_id !== actionMeta.removedValue.unique_id)
          .map((item, i) => ({ ...item, index: i + 1 })),
      );
    } else if (actionMeta.action === "clear") {
      setPortsForUpdate([]);
      setUpdatePorts([]);
      setVesselPorts([]);
    }
  };

  useEffect(() => {
    if (portsForUpdate.length === 0) {
      setPortsErrorMessage("");
      setShowPortsTerminalTooltip(false);
    }
  }, [portsForUpdate]);

  const resetPortsState = () => {
    setPortsErrorMessage("");
    setShowPortsTerminalTooltip(false);

    setVesselPorts([]);
    setUpdatePorts([]);
    setPortsForUpdate([]);

    setShowUpdateNameError(false);
    setShowUpdateNameTooltip(false);
  };

  const customFilter = createFilter({
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: "any",
  });

  const port_sequence = {};

  const formatOptionLabel = (data) => {
    const index = portsForUpdate.findIndex(
      (option) => option.value === data.value,
    );
    port_sequence[index] = {
      index: index + 1,
      id: data.value,
      name: data.label,
      unique_id: data.unique_id,
    };
    return (
      <div>
        {index !== -1 && (
          <span className="text-inox-green fw-bold" style={{ marginRight: 10 }}>
            {data.index}{" "}
          </span>
        )}{" "}
        {data.label}
      </div>
    );
  };

  const validatePorts = () => {
    // Check empty dropdown (port with no value)
    if (portsForUpdate.some((p) => !p.value)) {
      setPortsErrorMessage(
        "One or more ports have no value selected. Please remove empty entries.",
      );
      return false;
    }
    // Minimum 2 ports
    if (portsForUpdate.length < 2) {
      setPortsErrorMessage("At least 2 ports must be selected.");
      return false;
    }
    // No successive duplicates
    for (let i = 0; i < portsForUpdate.length - 1; i++) {
      if (portsForUpdate[i].value === portsForUpdate[i + 1].value) {
        setPortsErrorMessage(
          `Port "${portsForUpdate[i].label}" cannot appear twice in succession.`,
        );
        return false;
      }
    }
    return true;
  };

  const updateVesselPorts = async (e) => {
    e.preventDefault();

    // Run validation before submitting
    if (!validatePorts()) return;

    setShowAddVesselPortLoader(true);

    const id = updateId;
    const sequence = Object.assign({}, portsForUpdate);

    const data = {
      id: id,
      port:
        portsForUpdate.length > 0
          ? portsForUpdate.map((port) => port.value)
          : [],
      sequence: sequence,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.post(
      process.env.REACT_APP_BACKEND_API_URL +
        "/master/vesselservice/addserviceports/",
      data,
      { headers: { "content-type": "application/json" } },
    );

    if (response.status === 200) {
      toast.success("Vessel Service Ports Added Successfully");
    }

    getVesselService();
    const updatedPorts = Object.values(response.data?.result?.sequence);
    setVesselPorts(updatedPorts);
    getFreightCharge();

    // Auto-set return port if none is set after save
    autoSetReturnPort(updatedPorts, id);

    setShowAddVesselPortLoader(false);
  };

  const setSequencePortTerminal = async (e, port, terminal) => {
    e.preventDefault();
    if (terminal == "") {
      toast.warning("Select a Terminal");
    } else {
      setShowAddVesselPortLoader(true);
      const id = updateId;

      const data = {
        id: id,
        port: port,
        terminal: terminal,
        modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
      };

      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL +
          "/master/vesselservice/updateserviceportterminal/",
        data,
        { headers: { "content-type": "application/json" } },
      );

      if (response.status === 200) {
        toast.success("Vessel Service Terminal Updated Successfully");
      }

      getVesselService();
      setVesselPorts(Object.values(response.data?.result?.sequence));
      setShowAddVesselPortLoader(false);
    }
  };

  const setSequenceReturnPort = async (e, port, isReturnPort) => {
    e.preventDefault();
    setShowAddVesselPortLoader(true);
    const id = updateId;

    const data = {
      id: id,
      port: port,
      is_return_port: isReturnPort,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.post(
      process.env.REACT_APP_BACKEND_API_URL +
        "/master/vesselservice/setreturnport/",
      data,
      { headers: { "content-type": "application/json" } },
    );

    if (response.status === 200) {
      toast.success("Vessel Service Return Port Updated Successfully");
    }

    getVesselService();
    setVesselPorts(Object.values(response.data?.result?.sequence));
    setShowAddVesselPortLoader(false);
  };

  // -------------------------------------- Freight Charge --------------------------------------------
  const [showUpdateFreightOperatorError, setShowUpdateFreightOperatorError] =
    useState(false);
  const [showUpdatePolError, setShowUpdatePolError] = useState(false);
  const [showUpdatePodError, setShowUpdatePodError] = useState(false);
  const [showUpdateContainerError, setShowUpdateContainerError] =
    useState(false);
  const [showUpdateAmountError, setShowUpdateAmountError] = useState(false);
  const [showUpdateExpenseError, setShowUpdateExpenseError] = useState(false);
  const [showUpdateValidFromError, setShowUpdateValidFromError] =
    useState(false);
  const [showUpdateValidToError, setShowUpdateValidToError] = useState(false);

  const [updateSelectedFreightOperator, setUpdateSelectedFreightOperator] =
    useState(false);
  const [updateSelectedPol, setUpdateSelectedPol] = useState(false);
  const [updateSelectedPod, setUpdateSelectedPod] = useState(false);
  const [updateSelectedContainer, setUpdateSelectedContainer] = useState(false);
  const [updateAmount, setUpdateAmount] = useState(false);
  const [updateExpense, setUpdateExpense] = useState(false);
  const [updateValidFrom, setUpdateValidFrom] = useState(false);
  const [updateValidTo, setUpdateValidTo] = useState(false);

  const [freightChargesList, setFreightChargesList] = useState([]);
  const [freightChargeDataPending, setFreightChargeDataPending] =
    useState(false);
  const [freightPortList, setFreightPortList] = useState([]);
  const [containerList, setContainerList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [showUpdateFreightLoader, setShowUpdateFreightLoader] = useState(false);

  const getFreightCharge = async () => {
    setFreightChargeDataPending(true);
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/freightcharge/",
      );
      if (response) {
        setFreightChargesList(response.data);
        console.log("response.data", response.data);
      }
    } catch (err) {
      toast.error("Error in fetching freight charges data! Try again.");
    }
    setFreightChargeDataPending(false);
  };

  const getFreightPort = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/port/",
      );
      if (response) {
        const data = response.data.map((item) => ({
          value: item.id,
          label: item.name,
          type: item.type,
        }));
        const sorted_data = [...data].sort((a, b) =>
          a.label.localeCompare(b.label),
        );
        setFreightPortList(sorted_data);
      }
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getFreightOperator = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/operator/",
      );
      if (response) {
        const data = response.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        const sorted_data = [...data].sort((a, b) =>
          a.label.localeCompare(b.label),
        );
        setOperatorList(sorted_data);
      }
    } catch (err) {
      toast.error("Error in fetching operator data! Try again.");
    }
  };

  const getFreightContainer = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/product/",
      );
      if (response) {
        const data = response.data.map((item) => ({
          value: item.id,
          label: item.product_name,
        }));
        const sorted_data = [...data].sort((a, b) =>
          a.label.localeCompare(b.label),
        );
        setContainerList(sorted_data);
      }
    } catch (err) {
      toast.error("Error in fetching container data! Try again.");
    }
  };

  useEffect(() => {
    getFreightCharge();
    getFreightPort();
    getFreightOperator();
    getFreightContainer();
  }, []);

  const freightcolumns = [
    {
      name: "Operator",
      selector: (row) => row.operator_data?.name,
      sortable: true,
    },
    {
      name: "From Port",
      selector: (row) => row.pol_data?.name,
      sortable: true,
    },
    { name: "To Port", selector: (row) => row.pod_data?.name, sortable: true },
    {
      name: "Container",
      selector: (row) => row.container_data?.product_name,
      sortable: true,
    },
    { name: "Amount", selector: (row) => row.amount, sortable: true },
    { name: "Expense", selector: (row) => row.expense, sortable: true },
    { name: "Valid From", selector: (row) => row.valid_from, sortable: true },
    { name: "Valid To", selector: (row) => row.valid_to, sortable: true },
    {
      name: "Action",
      right: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes(
            "master:vesselservice:update",
          ) ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => handleSetUpdateData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}
          {currentUserRolePermissionData?.includes(
            "master:vesselservice:delete",
          ) ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const updateFreightCharge = (e) => {
    e.preventDefault();
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="VesselServiceMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Vessel Service Master</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:vesselservice:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0  px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Vessel Service</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button variant="danger" onClick={(e) => deleteVesselService(e)}>
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div
        className={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        data-bs-scroll="true"
        tabIndex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-4">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Update Record
              </h4>
              <Button
                className={`${showServiceDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowServiceDetails(true),
                  setShowServicePorts(false),
                  setShowServiceFreights(false),
                ]}
              >
                Details
              </Button>

              <Button
                className={`${showServicePorts ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => [
                  setShowServiceDetails(false),
                  setShowServicePorts(true),
                  setShowServiceFreights(false),
                ]}
              >
                Ports
              </Button>

              {/* Freights tab  */}
              {/* <Button className={`${showServiceFreights ? 'btn-inox-red' : 'btn-inox-green'} border-0 btn-sm`} style={{ marginRight: 10, width: 120 }}
                onClick={() => [setShowServiceDetails(false), setShowServicePorts(false), setShowServiceFreights(true)]}>
                Freights
              </Button> */}
            </div>
            <div className="col-8">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowUpdateCanvas(false);
                  resetPortsState();

                  setShowNameError(false);
                  setShowUpdateNameError(false);
                  setPortsErrorMessage("");

                  setShowPortsTerminalTooltip(false);
                  setShowUpdateNameTooltip(false);
                  setUpdateName("");
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="offcanvas-body">
          {/* Details Tab */}
          <div style={{ display: showServiceDetails ? "block" : "none" }}>
            <form
              onSubmit={(e) => updateVesselService(e)}
              style={{ marginLeft: 300 }}
            >
              <div className="row">
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                >
                  <label htmlFor="name">
                    Vessel Service Name: <i className="text-danger">*</i>
                    <span className="text-danger">
                      {showUpdateNameError
                        ? " Vessel Service Name required"
                        : ""}
                    </span>
                  </label>

                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="name"
                    name="name"
                    placeholder="Enter Vessel Service Name"
                    value={updateName}
                    onChange={(e) => {
                      setUpdateName(e.target.value);

                      if (e.target.value.trim()) {
                        setShowUpdateNameError(false);
                        setShowUpdateNameTooltip(false);
                      }
                    }}
                    onBlur={(e) => {
                      if (e.target.value.trim() === "") {
                        setShowUpdateNameError(true);
                      } else {
                        setShowUpdateNameError(false);
                      }
                    }}
                  />
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                >
                  <label htmlFor="status">Status: </label>
                  <select
                    className="form-select form-select-sm"
                    name="status"
                    onChange={(e) => setUpdateStatus(e.target.value)}
                  >
                    <option
                      value="ACTIVE"
                      selected={updateStatus == "ACTIVE" ? true : false}
                    >
                      ACTIVE
                    </option>
                    <option
                      value="INACTIVE"
                      selected={updateStatus == "INACTIVE" ? true : false}
                    >
                      INACTIVE
                    </option>
                  </select>
                </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                >
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button btn-sm mt-4"
                    disabled={!updateName.trim() || showUpdateLoader}
                  >
                    <i className="fa fa-edit"></i>
                    <span className="mx-2">
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-3 text-white"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Update"
                      )}
                    </span>
                  </Button>
                  {showUpdateNameError && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        className="ml-2"
                        onClick={() =>
                          setShowUpdateNameTooltip(!showUpdateNameTooltip)
                        }
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>

                      {showUpdateNameTooltip && (
                        <div className="validation-error-tooltip">
                          Vessel Service Name required
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>

          {/* Ports Tab */}
          <div style={{ display: showServicePorts ? "block" : "none" }}>
            <form onSubmit={(e) => updateVesselPorts(e)}>
              <div className="row" style={{ marginLeft: 250 }}>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-8" : "col-md-9"} text-left mb-4`}
                >
                  <label htmlFor="name">Ports: </label>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <div style={{ flex: 1 }}>
                      <Select
                        options={portsList}
                        value={updatePorts}
                        onChange={selectedServicePortForUpdate}
                        isMulti
                        closeMenuOnSelect={false}
                        placeholder="Select ports..."
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) =>
                          option.unique_id || option.value
                        }
                        filterOption={(option, inputValue) =>
                          customFilter(option, inputValue)
                        }
                        hideSelectedOptions={false}
                        formatOptionLabel={formatOptionLabel}
                        isOptionDisabled={() => false}
                      />
                    </div>
                    <Button
                      className="btn btn-inox-green border-0"
                      style={{ marginLeft: 16, whiteSpace: "nowrap" }}
                      onClick={(e) => updateVesselPorts(e)}
                      disabled={
                        portsErrorMessage !== "" || hasPortWithNoTerminal
                      }
                    >
                      <i
                        className={`fa ${updatePorts.length > 0 ? "fa-edit" : "fa-plus"}`}
                      ></i>
                      <span className="mx-2">
                        {showAddVesselPortLoader ? (
                          <Spinner
                            className="mx-3 text-white"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : updatePorts.length > 0 ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </span>
                    </Button>
                    {(hasPortWithNoTerminal || portsErrorMessage) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          onMouseLeave={() =>
                            setShowPortsTerminalTooltip(false)
                          }
                          onClick={() =>
                            setShowPortsTerminalTooltip(
                              !showPortsTerminalTooltip,
                            )
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {showPortsTerminalTooltip && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {hasPortWithNoTerminal && (
                                <li className="text-left small pb-0">
                                  Some ports have no terminal.
                                </li>
                              )}
                              {portsErrorMessage && (
                                <li className="text-left small pb-0">
                                  {portsErrorMessage}
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
            {/* <form
              onSubmit={(e) => updateVesselPorts(e)}
              style={{ marginLeft: 250 }}
            >
              <div className="row" style={{ alignItems: "flex-end" }}>
                <div
                  className={`form-group ${canvasFullScreen ? "col-md-8" : "col-md-8"} text-left mb-4`}
                >
                  <label htmlFor="name">Ports: </label>
                  <Select
                    options={portsList}
                    value={updatePorts}
                    onChange={selectedServicePortForUpdate}
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder="Select ports..."
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) =>
                      option.unique_id || option.value
                    }
                    filterOption={(option, inputValue) =>
                      customFilter(option, inputValue)
                    }
                    hideSelectedOptions={false}
                    formatOptionLabel={formatOptionLabel}
                    isOptionDisabled={() => false}
                  />
                  {/* Real-time ports validation error */}
            {/* </div>

                <div
                  className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
                >
                  <label>&nbsp;</label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      className="btn btn-inox-green border-0 canvas-button mt-4"
                      onClick={(e) => updateVesselPorts(e)}
                      disabled={
                        portsErrorMessage !== "" || hasPortWithNoTerminal
                      }
                    >
                      <i
                        className={`fa ${updatePorts.length > 0 ? "fa-edit" : "fa-plus"}`}
                      ></i>
                      <span className="mx-2">
                        {showAddVesselPortLoader ? (
                          <Spinner
                            className="mx-3 text-white"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : updatePorts.length > 0 ? (
                          "Update"
                        ) : (
                          "Add"
                        )}
                      </span>
                    </Button>
                    {(hasPortWithNoTerminal || portsErrorMessage) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onMouseLeave={() =>
                            setShowPortsTerminalTooltip(false)
                          }
                          onClick={() =>
                            setShowPortsTerminalTooltip(
                              !showPortsTerminalTooltip,
                            )
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {showPortsTerminalTooltip && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {hasPortWithNoTerminal && (
                                <li className="text-left small pb-0">
                                  Some ports have no terminal.
                                </li>
                              )}
                              {portsErrorMessage && (
                                <li className="text-left small pb-0">
                                  {portsErrorMessage}
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form> */}

            <div className="col-12 text-left">
              <h5 style={{ marginLeft: 250 }}>{updateName} Route:</h5>
              <ul
                style={{ listStyle: "none", marginLeft: 220, marginRight: 250 }}
              >
                <li className="mb-3">
                  <div className="row bg-light py-2">
                    <div className="col-4">Port</div>
                    <div className="col-4">Terminal</div>
                    <div className="col-4">Is Return Port?</div>
                  </div>
                </li>
                {vesselPorts?.map((port) => {
                  const terminalsForPort = vesselPortTerminal.filter(
                    (t) => t.port === (port.id || port.value),
                  );
                  const noTerminalAvailable = terminalsForPort.length === 0;
                  return (
                    <li key={port.unique_id || port.id}>
                      <div className="row">
                        <div className="col-4">
                          <span
                            className={`${port?.return_port == "YES" ? "fw-bold" : ""}`}
                          >
                            {port["index"]}. {port["label"] || port["name"]}
                            {port?.return_port == "YES" ? (
                              <i className="fa fa-undo mx-3"></i>
                            ) : (
                              ""
                            )}
                          </span>
                        </div>

                        <div className="col-4 mb-2">
                          <select
                            className={`form-select form-select-sm ${noTerminalAvailable ? "is-invalid" : ""}`}
                            onChange={(e) =>
                              setSequencePortTerminal(e, port, e.target.value)
                            }
                          >
                            <option value="">Select Terminal</option>
                            {terminalsForPort.map((terminal) => (
                              <option
                                key={terminal.value}
                                value={[terminal.value, terminal.label]}
                                selected={
                                  port?.terminal_id == terminal.value
                                    ? true
                                    : false
                                }
                              >
                                {terminal.label}
                              </option>
                            ))}
                          </select>
                          {/* No terminal error per port row */}
                          {noTerminalAvailable && (
                            <div
                              className="text-danger mt-1"
                              style={{ fontSize: 11 }}
                            >
                              <i className="fa fa-exclamation-circle mx-1"></i>
                              No terminal available for this port
                            </div>
                          )}
                        </div>

                        <div className="col-2 mb-2">
                          <select
                            className="form-select form-select-sm"
                            onChange={(e) =>
                              setSequenceReturnPort(e, port, e.target.value)
                            }
                          >
                            <option
                              value="NO"
                              selected={
                                port?.return_port == "NO" ? true : false
                              }
                            >
                              No
                            </option>
                            <option
                              value="YES"
                              selected={
                                port?.return_port == "YES" ? true : false
                              }
                            >
                              Yes
                            </option>
                          </select>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* Freights Tab  */}
          {/* <div style={{ display: showServiceFreights ? 'block' : 'none' }}>
            <form onSubmit={(e) => updateFreightCharge(e)}>
              <div className="row">
                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="name">Operator: <i className="text-danger">*</i><span className="text-danger">{showUpdateFreightOperatorError ? " Freight Operator required" : ""}</span></label>
                  <Select
                    options={operatorList}
                    id="update_freight_operator"
                    name="update_freight_operator"
                    onChange={(e) => setUpdateSelectedFreightOperator(e)}
                    isMulti={false}
                    placeholder="Select Operator"
                    value={updateSelectedFreightOperator ? { "value": updateSelectedFreightOperator?.value, "label": updateSelectedFreightOperator?.label } : "Select Operator"}
                    onBlur={(e) => e.value == "" ? setShowUpdateFreightOperatorError(true) : setShowUpdateFreightOperatorError(false)}
                    styles={smallFormSelectCustomStyles}
                  />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="name">POL: <i className="text-danger">*</i><span className="text-danger">{showUpdatePolError ? " POL required" : ""}</span></label>
                  <Select
                    options={freightPortList}
                    id="update_pol"
                    name="update_pol"
                    onChange={(e) => setUpdateSelectedPol(e)}
                    isMulti={false}
                    placeholder="Select Port"
                    value={updateSelectedPol ? { "value": updateSelectedPol?.value, "label": updateSelectedPol?.label } : "Select Port"}
                    onBlur={(e) => e.value == "" ? setShowUpdatePolError(true) : setShowUpdatePolError(false)}
                    styles={smallFormSelectCustomStyles}
                  />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="name">POD: <i className="text-danger">*</i><span className="text-danger">{showUpdatePodError ? " POD required" : ""}</span></label>
                  <Select
                    options={freightPortList}
                    id="update_pod"
                    name="update_pod"
                    onChange={(e) => setUpdateSelectedPod(e)}
                    isMulti={false}
                    placeholder="Select Port"
                    value={updateSelectedPod ? { "value": updateSelectedPod?.value, "label": updateSelectedPod?.label } : "Select Port"}
                    onBlur={(e) => e.value == "" ? setShowUpdatePodError(true) : setShowUpdatePodError(false)}
                    styles={smallFormSelectCustomStyles}
                  />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="name">Container: <i className="text-danger">*</i><span className="text-danger">{showUpdateContainerError ? " Container required" : ""}</span></label>
                  <Select
                    options={containerList}
                    id="update_container"
                    name="update_container"
                    onChange={(e) => setUpdateSelectedContainer(e)}
                    isMulti={false}
                    placeholder="Select Container"
                    value={updateSelectedContainer?.value ? { "value": updateSelectedContainer?.value, "label": updateSelectedContainer?.label } : "Select Container"}
                    onBlur={(e) => e.value == "" ? setShowUpdateContainerError(true) : setShowUpdateContainerError(false)}
                    styles={smallFormSelectCustomStyles}
                  />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="amount">Amount: <i className="text-danger">*</i><span className="text-danger">{showUpdateAmountError ? " Amount required" : ""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="amount" name="amount" placeholder="Enter Amount"
                    value={updateAmount} onChange={(e) => setUpdateAmount(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateAmountError(true) : setShowUpdateAmountError(false)} />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="expense">Expense: <i className="text-danger">*</i><span className="text-danger">{showUpdateExpenseError ? " Expense required" : ""}</span></label>
                  <input type="number" className="form-control form-control-sm" id="expense" name="expense" placeholder="Enter Expense"
                    value={updateExpense} onChange={(e) => setUpdateExpense(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateExpenseError(true) : setShowUpdateExpenseError(false)} />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="valid_from">Valid From: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidFromError ? " Date required" : ""}</span></label>
                  <input type="date" className="form-control form-control-sm" id="valid_from" name="valid_from" placeholder="Enter Date"
                    value={updateValidFrom} onChange={(e) => setUpdateValidFrom(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateValidFromError(true) : setShowUpdateValidFromError(false)} />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <label htmlFor="valid_to">Valid To: <i className="text-danger">*</i><span className="text-danger">{showUpdateValidToError ? " Date required" : ""}</span></label>
                  <input type="date" className="form-control form-control-sm" id="valid_to" name="valid_to" placeholder="Enter Date"
                    value={updateValidTo} onChange={(e) => setUpdateValidTo(e.target.value)}
                    onBlur={(e) => e.target.value == "" ? setShowUpdateValidToError(true) : setShowUpdateValidToError(false)} />
                </div>

                <div className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}>
                  <Button className="btn btn-inox-green border-0 canvas-button btn-sm mt-2" onClick={(e) => updateFreightCharge(e)}>
                    <i className="fa fa-edit"></i>
                    <span className="mx-2">
                      {showUpdateFreightLoader ?
                        <Spinner className="mx-3 text-white" as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        : "Update"}
                    </span>
                  </Button>
                </div>
              </div>
            </form>

            <DataTable
              columns={freightcolumns}
              data={freightChargesList}
              progressPending={freightChargeDataPending}
              progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
              noDataComponent={<p className="text-center py-5">No Freight Charges Found</p>}
              pagination
              highlightOnHover
              fixedHeader
              dense
              customStyles={importExportTableCustomStyles}
            />
          </div> */}
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div
        className={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabIndex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => {
                  setShowAddCanvas(false);

                  setShowNameError(false);
                  setPortsErrorMessage("");
                }}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="offcanvas-body">
          <form
            ref={addform}
            onSubmit={(e) => addVesselService(e)}
            style={{ marginLeft: 300 }}
          >
            <div className="row">
              <div
                className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label htmlFor="name">
                  Vessel Service Name: <i className="text-danger">*</i>
                </label>
                <div className="d-flex align-items-center">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="name"
                    name="name"
                    placeholder="Enter Vessel Service Name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                      setShowNameError(false);
                      setShowAddNameTooltip(false);
                    }}
                    onBlur={(e) => {
                      if (e.target.value === "") {
                        setShowNameError(true);
                      }
                    }}
                  />
                </div>
              </div>

              <div
                className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label htmlFor="status">Status: </label>
                <select
                  className="form-select form-select-sm"
                  name="status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="ACTIVE" selected>
                    ACTIVE
                  </option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              <div
                className={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <Button
                  type="submit"
                  className="btn btn-inox-green border-0 canvas-button btn-sm mt-4"
                  disabled={!name.trim() || showAddLoader}
                >
                  <i className="fa fa-plus"></i>
                  <span className="mx-2">
                    {showAddLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Add"
                    )}
                  </span>
                </Button>
                {showNameError && (
                  <div className="error-tooltip-wrapper ml-2">
                    <Button
                      style={{
                        backgroundColor: "#C21E22",
                        border: "#f82e2e",
                      }}
                      onClick={() => setShowAddNameTooltip(!showAddNameTooltip)}
                    >
                      <i className="fa fa-exclamation"></i>
                    </Button>

                    {showAddNameTooltip && (
                      <div className="validation-error-tooltip">
                        Vessel Service Name required
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default VesselServiceMaster;
